import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    checkboxAnatomy.keys
);

const baseStyle = definePartsStyle({
    control: {
        rounded: '0.25rem',
        marginTop: '0.1rem',
        borderColor: 'blue.600',
        _invalid: {
            borderColor: 'red.400'
        }
    },
    label: {
        marginLeft: '1.125rem',
        fontSize: { base: '12px', md: 'initial' }
    }
});

const variantBgWhite = definePartsStyle({
    control: {
        bgColor: 'white',
        borderColor: 'grey.400',
        borderWidth: '1px'
    }
});

const variants = {
    bgWhite: variantBgWhite
};

export const Checkbox = defineMultiStyleConfig({ baseStyle, variants });
